/**
 * Keeps Amada PDP option headers (`[data-amada-option-value]`) in sync with
 * Fabric variant-picker radios as the shopper changes metal / carat / size.
 */
function syncFieldsetHeader(fieldset) {
  if (!(fieldset instanceof HTMLElement)) return;
  const valueEl = fieldset.querySelector('[data-amada-option-value]');
  if (!valueEl) return;

  const checked = fieldset.querySelector(
    'input[type="radio"]:checked, input[type="checkbox"]:checked'
  );
  if (!(checked instanceof HTMLInputElement)) {
    valueEl.hidden = true;
    valueEl.textContent = '';
    return;
  }

  const label = checked.closest('label');
  const text =
    label?.querySelector('.variant-option__button-label__text')?.textContent?.trim()
    || label?.querySelector('span:not(.visually-hidden):not(.variant-option__button-label__pill)')?.textContent?.trim()
    || checked.getAttribute('aria-label')
    || checked.value;

  valueEl.textContent = text || '';
  valueEl.hidden = !text;
}

function syncAll(root = document) {
  root.querySelectorAll('.product-information fieldset.variant-option--buttons').forEach(syncFieldsetHeader);
}

function onChange(event) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement)) return;
  if (target.type !== 'radio' && target.type !== 'checkbox') return;
  const fieldset = target.closest('fieldset.variant-option--buttons');
  if (fieldset) syncFieldsetHeader(fieldset);
}

document.addEventListener('change', onChange);

const boot = () => syncAll();
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target instanceof Element ? event.target : document;
  syncAll(root);
});

// After Fabric variant morph replaces the picker, re-bind header values.
document.addEventListener('product-selected', () => {
  requestAnimationFrame(() => syncAll());
});
